













































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import WorkOrderListView from '@/components/orders/WorkOrderListView.vue';

import {
  PerformoSettings,
  QueryWorkOrdersRequest,
  ReportsApi,
  Workorder,
  WorkorderPagedCollectionApiResponse
} from 'performo-api';

import { User } from 'oidc-client';
import { mapGetters } from 'vuex';

@Component({
  components: {
    WorkOrderListView
  },
  computed: mapGetters({
    settings: 'settings',
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    reportsApi: 'reportsApi'
  })
})
export default class OrderList extends Vue {
  private currentPropertyId!: string;
  private currentUser!: User;

  private settings!: PerformoSettings;

  private query!: QueryWorkOrdersRequest;

  private pagedOrders!: WorkorderPagedCollectionApiResponse;

  private reportsApi!: ReportsApi;

  private startDateRange: Date[] = [];
  private completionDateRange: Date[] = [];

  private queryUpdatedFromPagination = false;

  private updateRouteWithQuery = true;

  private orderClickedHandler(order: Workorder) {
    if (order.workorderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: order.workorderId }
      });
    }
  }

  data() {
    return {
      query: undefined,
      orders: undefined,
      updateRouteWithQuery: true
    };
  }

  @Watch('startDateRange')
  private startDateRangeChanged(dates: Date[]) {
    if (dates) {
      this.query.startDateStart = dates[0];
      this.query.startDateEnd = dates[1];
    } else {
      this.query.startDateStart = undefined;
      this.query.startDateEnd = undefined;
    }
  }

  @Watch('completionDateRange')
  private completionDateRangeChanged(dates: Date[]) {
    if (dates) {
      this.query.completionDateStart = dates[0];
      this.query.completionDateEnd = dates[1];
    } else {
      this.query.completionDateStart = undefined;
      this.query.completionDateEnd = undefined;
    }
  }

  @Watch('query', { deep: true })
  private queryChanged() {
    const routeSkip = parseInt(this.$route.query.skip as string);

    this.query.skip = this.queryUpdatedFromPagination
      ? this.query.skip
      : isNaN(routeSkip)
      ? 0
      : routeSkip;

    this.queryUpdatedFromPagination = false;
  }

  @Watch('query.orderStatus')
  private orderStatusChanged(
    _newVal: string | undefined,
    oldVal: string | undefined
  ) {
    // return if we didn't already have an order status
    // this prevents the value being reset when
    // the query object is being populated by the route query
    if (oldVal == undefined) return;
    // remove includeSubStatuses from query when order status changes
    // only if it is already set
    if (this.query.includeSubStatuses != undefined) {
      this.query.includeSubStatuses = undefined;
    }
  }

  private listUpdated(ord: WorkorderPagedCollectionApiResponse) {
    this.pagedOrders = ord;
  }

  private handlePrint(reportId: number) {
    if (this.pagedOrders.data && this.pagedOrders.data?.length > 0) {
      let foundIds = '';
      this.pagedOrders.data.forEach((element: Workorder) => {
        foundIds += '\n' + element.workorderId;
      });
      this.reportsApi
        .queueReport({
          queueReportCommand: {
            outputType: 'PDF',
            propertyId: this.currentPropertyId,
            reportName: 'Work Order List Report',
            reportId: reportId,
            foundSetIds: foundIds
          }
        })
        .then(this.printSuccess);
      // 1000 = detail
      // 1002 = list, details
      // 1004 = list, list
    }
  }

  private handleFilterReset() {
    this.query = {
      orderStatus: 'Open',
      sortColumn: 'startDateTime',
      sortDirection: 'descend',
      startDateStart: undefined,
      startDateEnd: undefined,
      completionDateStart: undefined,
      completionDateEnd: undefined
    };
    //Clears out query & UI for dates because they are not using v-model
    this.startDateRange = [];
    this.completionDateRange = [];
  }

  private async printSuccess() {
    this.$router.push({ name: 'reports', params: {} });
  }

  private async paginationChangeHandler(pageNumber: number) {
    this.queryUpdatedFromPagination = true;
    this.query.skip = 25 * (pageNumber - 1) + 1;
  }

  private async setQuery() {
    if (Object.keys(this.$route.query).length > 0) {
      // assign the query string parameters to the query object
      this.query = Object.assign({}, this.$route.query);

      // range helpers
      if (this.$route.query['startDateStart'] as string) {
        this.query.startDateStart = new Date(
          this.$route.query['startDateStart'] as string
        );
        this.startDateRange[0] = this.query.startDateStart;
      }
      if (this.$route.query['startDateEnd'] as string) {
        this.query.startDateEnd = new Date(
          this.$route.query['startDateEnd'] as string
        );
        this.startDateRange[1] = this.query.startDateEnd;
      }

      if (this.$route.query['completionDateStart'] as string) {
        this.query.completionDateStart = new Date(
          this.$route.query['completionDateStart'] as string
        );
        this.completionDateRange[0] = this.query.completionDateStart;
      }
      if (this.$route.query['completionDateEnd'] as string) {
        this.query.completionDateEnd = new Date(
          this.$route.query['completionDateEnd'] as string
        );
        this.completionDateRange[1] = this.query.completionDateEnd;
      }
    } else {
      // setup the default query
      this.query = {
        orderStatus: 'Open',
        sortColumn: 'startDateTime',
        sortDirection: 'descend',
        skip: 0,
        startDateStart: undefined,
        startDateEnd: undefined,
        completionDateStart: undefined,
        completionDateEnd: undefined
      };
    }
  }

  private async mounted() {
    this.setQuery();
  }

  private created() {
    window.addEventListener('popstate', this.handleBackOnList);
  }
  private destroyed() {
    window.removeEventListener('popstate', this.handleBackOnList);
  }

  private handleBackOnList() {
    // don't load the query if we're backing out of the list (aka no query)
    if (
      document.location.pathname === '/orders' &&
      document.location.search === ''
    ) {
      return;
    }

    // re-lookup the query (from the url) when the browser back button is used.
    this.updateRouteWithQuery = false;
    this.setQuery();
    this.updateRouteWithQuery = true;
  }
}
